<!--
 * @Author: pgee
 * @Date: 2021-07-14 17:06:21
 * @LastEditTime: 2021-08-24 09:44:45
 * @LastEditors: Please set LastEditors
 * @Description: 
 * @FilePath: /yiqijian_video/template/web/pc/yiqijian-video/components/header.vue
-->
<template>
  <div
    :class="['header', { 'header-bg': !gradual }, headerClass]"
    :style="headerStyle"
  >
    <div class="left">
      <a href="/" class="logo" title="一起剪">
        <h1 title="一起剪">一起剪</h1>
      </a>
      <nav class="header-nav">
        <a
          class="nav-item"
          href="https://yiqijian.com"
          title="免费视频剪辑 - 一起剪"
          >
          免费视频剪辑
          <SvgIcon class="icon-hot" name="icon-hot" />
        </a>
        <div class="nav-item">
          <Dropdown>
            <a class="nav-label" href="javascript:void(0)" title="产品">
              产品
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <div slot="list" class="dropdown-list product">
              <template v-for="item in productList">
                <a class="dropdown-item" 
                  :href="item.value" 
                  :key="item.id" 
                  :title="item.label"
                  target="_blank">
                    {{item.label}}
                </a>
              </template>
            </div>
          </Dropdown>
        </div>
        <div class="nav-item">
          <Dropdown>
            <a class="nav-label" href="javascript:void(0)" title="合作">
              合作
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <div slot="list" class="dropdown-list">
              <template v-for="item in serviceList">
                <a class="dropdown-item" 
                  :href="item.value" 
                  :key="item.id" 
                  :title="item.label"
                  target="_blank">
                    {{item.label}}
                </a>
              </template>
            </div>
          </Dropdown>
        </div>
      </nav>
    </div>
    <div class="search-box" v-show="showSearch">
      <SearchInput prefix="ios-search" :value="searchValue" @change="handleChangeSearch" @search="handleSearch" openHistory />
    </div>
    <!-- 暂时隐藏 start -->
    <section class="right">
      <a
        href="//mp.yiqijian.com"
        title="一起剪"
        class="reset-btn login"
        v-if="false"
      >
        登录
      </a>
      <a
        href="//account.yiqijian.com/auth/register?referer=https%3A%2F%2Fmp.yiqijian.com%2Fdashboard"
        title="一起剪"
        class="reset-btn register"
        v-if="false"
      >
        注册
      </a>
    </section>
    <!-- 暂时隐藏 end -->
  </div>
</template>

<script>
import mixin from '../../mixins'
import { Trash2Icon } from 'vue-feather-icons'
import SearchInput from '../SearchInput'
import SvgIcon from '../SvgIcon.vue'

export default {
  mixins: [mixin],
  props: {
    gradual: {
      type: Boolean,
      default: false
    },
    headerClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },
    // 滚动到一定距离才显示input，默认常显示，0常显，负数隐藏，正数移动到指定高度才显示
    visibilityHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    headerStyle() {
      if (!this.gradual) return

      const styles = {
        backgroundColor: `rgba(255, 255, 255, ${this.opacity})`
      }

      if (this.opacity >= 0.5) {
        styles.color = `rgba(51, 51, 51, ${this.opacity})`
      }

      if (this.opacity >= 1) {
        styles.boxShadow = `0px 4px 16px 0px rgba(0, 0, 0, 0.05)`
      }

      return styles
    },
    showSearch() {
      if (!this.visibilityHeight) return true
      if (this.visibilityHeight < 0) return false

      return this.visibilityHeight && this.searchVisible
    },
  },
  data() {
    return {
      opacity: 0,
      searchVisible: false,
      productList: [
        {
          id: 1,
          label: '行业资讯汇聚',
          value: 'https://www.yiqijian.com/hot-news'
        },
        {
          id: 2,
          label: '海量剪辑素材',
          value: 'https://www.yiqijian.com/material'
        },
        {
          id: 3,
          label: '网络视频提取',
          value: 'https://www.yiqijian.com/video-collector'
        },
        {
          id: 4,
          label: '实时视频热榜',
          value: 'https://www.yiqijian.com/hot-videos'
        },
        {
          id: 5,
          label: '视频模板定制',
          value: 'https://www.yiqijian.com/video-templates'
        },
        {
          id: 6,
          label: '智能在线剪辑',
          value: 'https://www.yiqijian.com/smart-editor'
        },
        {
          id: 7,
          label: '字幕语音播报',
          value: 'https://www.yiqijian.com/auto-sounds'
        },
        {
          id: 8,
          label: '视频云端合成',
          value: 'https://www.yiqijian.com/cloud-maker'
        },
        {
          id: 9,
          label: '视频一键发布',
          value: 'https://www.yiqijian.com/one-step'
        },
        {
          id: 10,
          label: '团队管理',
          value: 'https://www.yiqijian.com/team-manager'
        }
      ],
      serviceList: [
        {
          id: 1,
          label: '私有部署',
          value: 'https://www.yiqijian.com/deploy'
        },
        {
          id: 2,
          label: '开放接入',
          value: 'https://www.yiqijian.com/open-access'
        },
        {
          id: 3,
          label: '融媒体解决方案',
          value: 'http://rongmeiti.myzaker.com/'
        }
      ]
    }
  },
  methods: {
    handleChangeSearch(value) {
      this.$emit('update:searchValue', value)
    },
    /**
     * @description: 搜索
     * @param {string} value
     * @return {void}
     */
    handleSearch(value) {
      this.$emit('search', value)
    },
    /**
     * @description: 监听滚动
     * @param {object} e
     * @return {void}
     */

    _handleScroll() {
      if (!this.visibilityHeight || this.visibilityHeight < 0) return

      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const ratio = (scrollTop / this.visibilityHeight).toFixed(2)
      const opacity =
        ratio >= 1
          ? 1
          : ratio >= 0.8 ? 0.8 : ratio
      this.opacity = opacity
      this.searchVisible = scrollTop >= this.visibilityHeight // 是否满足要求显示搜索框
    }
  },
  mounted() {
    window.addEventListener('scroll', this._handleScroll)
  },
  beforeMount() {
    window.removeEventListener('scroll', this._handleScroll)
  },
  components: {
    Trash2Icon,
    SearchInput,
    SvgIcon
  }
}
</script>

<style lang="less">
@pc-height: 80px;
@left_right-w: 512px;

.header {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  // min-width: 1216px;
  height: @pc-height;
  padding: 0 60px;
  z-index: 1100;
  box-sizing: border-box;
  color: #333;
  // transition: all 0.1s;
  will-change: background-color, box-shadow;

  &.header-bg {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.05);
    background-color: #fff;
  }

  .search-box {
    flex-grow: 2;
    max-width: 640px;
  }

  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
    width: @left_right-w;

    a {
      color: inherit
    }

    .logo {
      display: block;
      width: 99px;
      height: 47px;
      background-image: url('../../assets/img/logo.svg');
      background-size: cover;
      background-repeat: no-repeat;
      color: transparent;
    }

    .header-nav {
      margin-left: 56px;
    }

    .nav-item {
      display: inline-block;
      font-weight: bold;
      font-size: 18px;
      margin-right: 40px;

      .icon-hot {
        width: 32px;
        height: 16px;
        vertical-align: middle;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        color: #3771e4;

        .ivu-icon-ios-arrow-down {
          transform: rotate(180deg);
        }
      }

      .ivu-select-dropdown {
        margin: 20px 0;
        border-radius: 8px;
      }

      // 下拉列表动画
      .ivu-icon-ios-arrow-down {
        transition: transform .2s;
      }
    }

    .nav-label {
      font-weight: bold;
      font-size: 18px;
    }

    .dropdown-list {
      padding: 5px 15px;
      color: #3b3b3b;
      user-select: none;

      &.product {
        display: flex;
        width: 330px;
        flex-wrap: wrap;
      }

      .dropdown-item {
        display: block;
        width: 150px;
        padding: 10px 15px;
        text-align: center;
        font-size: 16px;
        line-height: 22px;
        
        &:hover {
          color: #3771e4;
        }
      }
    }
  }

  .right {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: @left_right-w;
  }

  .login {
    flex-shrink: 0;
    margin-right: 10px;
    color: #ffffff;
    background-color: #3771e4;
    vertical-align: middle;
    transition: background-color 0.2s;
    will-change: background-color;

    &:hover {
      background-color: #6196f2;
      color: #ffffff;
    }

    &:active {
      background-color: #2453bf;
    }
  }

  .register {
    color: #3771e5;
    width: 92px;
    height: 42px;
    border: 1px solid #3771e5;
    vertical-align: middle;
    border-radius: 8px;
    transition: border-color 0.2s, color 0.2s;
    will-change: border-color, color;

    &:hover {
      border-color: #6196f2;
      color: #6196f2;
    }

    &:active {
      border-color: #2453bf;
    }
  }

  .reset-btn {
    display: inline-block;
    padding: 0;
    margin: 0;
    width: 92px;
    height: 42px;
    font-size: 16px;
    font-weight: bold;
    color: #3771e4;
    line-height: 42px;
    border-radius: 8px;
    background-color: transparent;
    border: none;
    text-align: center;

    &::after {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?74cb9f2a